/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const SlideshowIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Slideshow',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m13.75,16h-7.5c-1.24072,0-2.25-1.00977-2.25-2.25v-7.5c0-1.24023,1.00928-2.25,2.25-2.25h7.5c1.24072,0,2.25,1.00977,2.25,2.25v7.5c0,1.24023-1.00928,2.25-2.25,2.25ZM6.25,5.5c-.41357,0-.75.33691-.75.75v7.5c0,.41309.33643.75.75.75h7.5c.41357,0,.75-.33691.75-.75v-7.5c0-.41309-.33643-.75-.75-.75h-7.5Z"
      fill="currentColor"
    />
    <path
      d="m1.75,14.75c-.41406,0-.75-.33594-.75-.75V6c0-.41406.33594-.75.75-.75s.75.33594.75.75v8c0,.41406-.33594.75-.75.75Z"
      fill="currentColor"
    />
    <path
      d="m18.25,14.75c-.41406,0-.75-.33594-.75-.75V6c0-.41406.33594-.75.75-.75s.75.33594.75.75v8c0,.41406-.33594.75-.75.75Z"
      fill="currentColor"
    />
    <path
      d="m12.19618,9.41442l-3.17813-1.70809c-.46031-.2474-1.01805.08603-1.01805.60862v3.41618c0,.52258.55773.85601,1.01805.60861l3.17814-1.7081c.48512-.26073.48512-.95649,0-1.21722Z"
      fill="currentColor"
    />
  </svg>`;
};
